// eslint-disable-next-line
import React from 'react';
import { FaGithub, FaLinkedin, FaTwitterSquare } from 'react-icons/fa';

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      <div className="footer">
        <h4 className="heading-footer">Find me on</h4>
        <div className="social-links">
          <a
            href="https://github.com/srishti-maurya"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub size={30} />
          </a>
          <a
            href="https://www.linkedin.com/in/mauryasrishti22/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin size={30} />
          </a>
          <a
            href="https://twitter.com/SrishtiMaurya1?s=09"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitterSquare size={30} />
          </a>
        </div>
        <p className="body-copyright">
          Designed and Developed with ❤️ by Srishti Maurya, Copyright © {year}
        </p>
      </div>
    </footer>
  );
}
export default Footer;
